import { render, staticRenderFns } from "./detailRow.vue?vue&type=template&id=768239d4&"
import script from "./detailRow.vue?vue&type=script&lang=js&"
export * from "./detailRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports